import React, { useState } from 'react';
import { Button } from '../UI';
import { useTranslation } from 'react-i18next';
import CheckoutModal from './CheckoutModal';

const ExpirationWarning: React.FC = () => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return isModalOpen ? (
    <CheckoutModal setIsModalOpen={setIsModalOpen} />
  ) : (
    <div className={'bg-orange flex flex-col items-center gap-3 py-8'}>
      <h3 className={'text-xl font-semibold'}>{t('payments.aboutExpire')}</h3>
      <p className={'text-md'}>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet culpa
        odio sed? Eligendi error expedita, molestias nemo non reiciendis sed!
      </p>
      <Button
        variant={'tertiary'}
        buttonClass={'mt-1'}
        onClick={() => setIsModalOpen(true)}
      >
        {t('payments.updatePaymentMethod')}
      </Button>
    </div>
  );
};

export default ExpirationWarning;
